export default __webpack_public_path__ + "static/media/ImportCustomer.314791f4.csv";